import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";
import { getQuery } from "../_helpers/query.helper";

const API_NAME = "users";

export const usersService = {
    getAllUsers,
    getAllAccounts,
    get,
    getOrganisers,
    getAdmins,
    dropdown
};

function getAllUsers(query: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetAllUsers?${getQuery(query)}`, requestOptions).then(handleResponse);
}
function getAllAccounts(query: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetAllAccounts?${getQuery(query)}`, requestOptions).then(handleResponse);
}
function get(id: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/Get/?id=${id}`, requestOptions).then(handleResponse);
}

function getOrganisers() {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetOrganisers`, requestOptions).then(handleResponse);
}

function getAdmins() {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getAdmins`, requestOptions).then(handleResponse);
}

function dropdown(parentId?: string | number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetDropdown/?parentId=` + parentId, requestOptions).then(handleResponse);
}
